import { View } from "./View";
import {
  IFormWithTableProps,
  IViewProduct,
} from "../../../interfaces-and-types";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useMerchantApiQueryWithParams,
  useReactRouterLink,
} from "../../../hooks";

export interface IProductDetailsModalViewProps {
  isLoading: boolean;
  isError: boolean;
  isModalOpen: boolean;
  closeModal: () => void;
  modalData: IViewProduct | null;
}

export const ProductDetailsModal = () => {
  const { location, navigateToRoutePreserveParams } = useReactRouterLink();

  const closeModal = () => {
    navigateToRoutePreserveParams(
      location.pathname.replace(`/${id}/details`, "")
    );
  };

  const { id } = useParams();

  const {
    isLoading,
    // isSuccess,
    isError,
    data: product,
  } = useMerchantApiQueryWithParams<{ id: string }, IViewProduct>(
    [
      "getProductById",
      {
        id: id!, // NOTE: used to enforce react query cache with correct queryKey
      },
    ],
    {
      enabled: !!id,
    },
    (urlTemplate) => urlTemplate.replace("id", id!)
  );

  return (
    <View
      isLoading={isLoading}
      isError={isError}
      isModalOpen={!!id}
      closeModal={closeModal}
      modalData={product || null}
    />
  );
};
